import { all, call, put, take, takeEvery } from 'redux-saga/effects'
import { t } from 'ttag'
import { getWhoAmI, getWhoAmIFail, getWhoAmISuccess } from '../../../common/auth/authActions'
import { addNotification, clearNotification } from '../../../common/notifications/NotificationActions'
import { INotification } from '../../../common/notifications/NotificationReducers'
import api from '../../../services/api.services'
import { doSignUp } from './SignUpActions'
import { push } from 'connected-react-router'
import { getErrorMsg } from '../../../common/helpers/translations'
import { SavePassword } from 'capacitor-ios-autofill-save-password'
import { Capacitor } from '@capacitor/core'

function* sagaSignUp({ payload }: any) {
  try {
    const { companyCode, email, password, lang } = payload
    yield put({ type: String(clearNotification) })
    yield call(api.auth.signUp, { companyCode, email, password, lang })

    // Ensure that you're logged in now.
    yield put({ type: String(getWhoAmI) })

    // Wait for getWhoAmI to finish.
    yield take([String(getWhoAmISuccess), String(getWhoAmIFail)])

    const successfulSignupNotification: INotification = {
      type: 'success',
      content: t`Great, you've successfully registered! For next, please choose your integration.`,
    }
    yield put({ type: String(addNotification), payload: successfulSignupNotification })

    if (Capacitor.getPlatform() === 'ios' && email && password) {
      yield SavePassword.promptDialog({
        username: email,
        password: password,
      })
    }

    yield put(push('/register-user'))
  } catch (e: any) {
    if (e.message && e.message === 'invalidCompanyCode') {
      const signupErrorNotification: INotification = {
        type: 'warning',
        content: t`Sorry, the sign up code provided is not valid`,
      }
      yield put({ type: String(addNotification), payload: signupErrorNotification })
    } else if (e.message && e.message === 'emailExists') {
      const signupErrorNotification: INotification = {
        type: 'warning',
        content: t`A user with the same email address exists`,
      }
      yield put({ type: String(addNotification), payload: signupErrorNotification })
    } else if (e.message && e.message === 'disallowedDomain') {
      const signupErrorNotification: INotification = {
        type: 'warning',
        content: t`Sorry, the sign up code provided does not allow signing up with the specified email address. Please sign up using another email address or contact your employer.`,
      }
      yield put({ type: String(addNotification), payload: signupErrorNotification })
    } else if (e.message && e.message === 'disallowedRegion') {
      const signupErrorNotification: INotification = {
        type: 'warning',
        content: t`Sorry, the given sign up code does not allow signing up from your region.`,
      }
      yield put({ type: String(addNotification), payload: signupErrorNotification })
    } else if (e.message && e.message === 'userLimitExceeded') {
      const signupErrorNotification: INotification = {
        type: 'warning',
        content: t`Sorry, this community has exceeded it's user limit. Please contact your challenge organizer for more info.`,
      }
      yield put({ type: String(addNotification), payload: signupErrorNotification })
    } else {
      const signupErrorNotification: INotification = {
        type: 'warning',
        content: getErrorMsg(
          e.message && e.message !== 'No message has been provided by the server' ? e.message : undefined,
        ),
      }
      yield put({ type: String(addNotification), payload: signupErrorNotification })
    }
  }
}

export function* signUpSagas() {
  yield all([takeEvery(String(doSignUp), sagaSignUp)])
}
